var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 149.59,
    height: 149.59,
    viewBox: "0 0 149.59 149.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 149.59,
    height: 149.59,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M149.589,74.8A74.8,74.8,0,1,1,74.794,0,74.795,74.795,0,0,1,149.589,74.8",
    transform: "translate(0 0)",
    fill: "#205583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.795,76.025A63.77,63.77,0,1,1,76.024,12.254a63.771,63.771,0,0,1,63.771,63.771",
    transform: "translate(-1.229 -1.229)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.874,140.994a65.12,65.12,0,1,1,65.119-65.119,65.194,65.194,0,0,1-65.119,65.119m0-127.541a62.421,62.421,0,1,0,62.42,62.421,62.492,62.492,0,0,0-62.42-62.421",
    transform: "translate(-1.079 -1.079)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.795,76.025A63.77,63.77,0,1,1,76.024,12.254a63.771,63.771,0,0,1,63.771,63.771",
    transform: "translate(-1.229 -1.229)",
    fill: "#205583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.874,140.994a65.12,65.12,0,1,1,65.119-65.119,65.194,65.194,0,0,1-65.119,65.119m0-127.541a62.421,62.421,0,1,0,62.42,62.421,62.492,62.492,0,0,0-62.42-62.421",
    transform: "translate(-1.079 -1.079)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.254,76.025a63.77,63.77,0,1,1,127.541,0Z",
    transform: "translate(-1.229 -1.229)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.993,77.224H10.753v-1.35a65.12,65.12,0,1,1,130.24,0Zm-127.526-2.7H138.279a62.421,62.421,0,0,0-124.813,0",
    transform: "translate(-1.079 -1.079)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.277,84.136l-25.241,53.44a63.795,63.795,0,0,0,66.29.287L86.95,84.136Z",
    transform: "translate(-4.619 -8.441)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.219,148.2a64.972,64.972,0,0,1-34.083-9.631l-1.028-.633,26.121-55.3H87.612l26.262,55.6-1.044.63A65,65,0,0,1,79.219,148.2M47.584,136.9a62.459,62.459,0,0,0,62.8.278L85.9,85.335H71.938Z",
    transform: "translate(-4.425 -8.29)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 62.528,
    transform: "translate(74.358 76.555)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.699,
    height: 62.528,
    transform: "translate(73.009 76.554)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.858,43.819a4.948,4.948,0,0,1,6.471-6.288,6.8,6.8,0,1,1,13.193,2.282,8.25,8.25,0,0,1-.716,16.47H49.969a6.281,6.281,0,0,1-1.111-12.465",
    transform: "translate(-4.382 -3.09)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.655,57.483H49.818A7.632,7.632,0,0,1,47.1,42.719a5.739,5.739,0,0,1-.043-.7,6.339,6.339,0,0,1,6.332-6.332,6.118,6.118,0,0,1,.628.033A8.146,8.146,0,0,1,70.121,37.45a7.479,7.479,0,0,1-.087,1.127,9.53,9.53,0,0,1,7.242,9.285,9.632,9.632,0,0,1-9.621,9.621m-14.268-19.1a3.637,3.637,0,0,0-3.633,3.633,3.584,3.584,0,0,0,.225,1.2A1.35,1.35,0,0,1,48.946,45a4.932,4.932,0,0,0,.873,9.787H67.655a6.9,6.9,0,0,0,.6-13.777A1.349,1.349,0,0,1,67.1,39.222a5.376,5.376,0,0,0,.326-1.771,5.447,5.447,0,0,0-10.894-.056,1.349,1.349,0,0,1-1.837,1.244,3.621,3.621,0,0,0-1.3-.255",
    transform: "translate(-4.232 -2.94)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 17.557,
    transform: "translate(56.618 52.976)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.699,
    height: 17.557,
    transform: "translate(55.269 52.976)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 17.951,
    transform: "translate(56.618 35.025)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.781,58.08a1.35,1.35,0,0,1-1.35-1.35V38.78a1.35,1.35,0,0,1,2.7,0V56.731a1.35,1.35,0,0,1-1.35,1.35",
    transform: "translate(-6.163 -3.755)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.657,
    y2: 3.789,
    transform: "translate(56.618 43.82)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.781,53.694a1.349,1.349,0,0,1-.752-2.471l5.657-3.789a1.349,1.349,0,0,1,1.5,2.242l-5.657,3.789a1.344,1.344,0,0,1-.75.229",
    transform: "translate(-6.163 -4.736)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    x2: 5.657,
    y2: 3.789,
    transform: "translate(50.96 40.375)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.15,49.866a1.344,1.344,0,0,1-.75-.229l-5.657-3.789a1.349,1.349,0,1,1,1.5-2.242L62.9,47.4a1.349,1.349,0,0,1-.752,2.471",
    transform: "translate(-5.532 -4.352)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.323,43.819a4.948,4.948,0,0,0-6.471-6.288,6.8,6.8,0,1,0-13.193,2.282,8.25,8.25,0,0,0,.716,16.47h17.837a6.281,6.281,0,0,0,1.111-12.465",
    transform: "translate(-8.638 -3.09)",
    fill: "#205583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.061,57.483H94.224A9.632,9.632,0,0,1,84.6,47.862a9.528,9.528,0,0,1,7.242-9.285,7.479,7.479,0,0,1-.087-1.127,8.146,8.146,0,0,1,16.106-1.732,5.873,5.873,0,0,1,.628-.033,6.339,6.339,0,0,1,6.332,6.332,5.751,5.751,0,0,1-.043.7,7.632,7.632,0,0,1-2.72,14.765M99.907,32a5.457,5.457,0,0,0-5.45,5.45,5.371,5.371,0,0,0,.326,1.771,1.35,1.35,0,0,1-1.157,1.787,6.9,6.9,0,0,0,.6,13.777h17.837A4.932,4.932,0,0,0,112.934,45a1.348,1.348,0,0,1-1.035-1.778,3.58,3.58,0,0,0,.226-1.2,3.63,3.63,0,0,0-4.936-3.378,1.349,1.349,0,0,1-1.838-1.244A5.465,5.465,0,0,0,99.907,32",
    transform: "translate(-8.488 -2.94)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 17.557,
    transform: "translate(92.542 52.976)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.699,
    height: 17.557,
    transform: "translate(91.192 52.976)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 17.951,
    transform: "translate(92.542 35.025)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.711,58.08a1.35,1.35,0,0,1-1.35-1.35V38.78a1.35,1.35,0,1,1,2.7,0V56.731a1.35,1.35,0,0,1-1.35,1.35",
    transform: "translate(-10.169 -3.755)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    x2: 5.657,
    y2: 3.789,
    transform: "translate(86.884 43.82)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.079,53.694a1.344,1.344,0,0,1-.75-.229l-5.657-3.789a1.349,1.349,0,0,1,1.5-2.242l5.657,3.789a1.35,1.35,0,0,1-.752,2.471",
    transform: "translate(-9.538 -4.736)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.657,
    y2: 3.789,
    transform: "translate(92.542 40.375)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.711,49.866a1.349,1.349,0,0,1-.752-2.471l5.657-3.789a1.349,1.349,0,0,1,1.5,2.242l-5.657,3.789a1.344,1.344,0,0,1-.75.229",
    transform: "translate(-10.169 -4.352)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.483,74.864A6.187,6.187,0,0,1,34.572,67a8.5,8.5,0,0,1,16.991.087,8.4,8.4,0,0,1-.5,2.766,10.312,10.312,0,0,1-.9,20.588h-22.3a7.852,7.852,0,0,1-1.388-15.581",
    transform: "translate(-2.008 -5.878)",
    fill: "#205583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.018,91.644h-22.3a9.2,9.2,0,0,1-3.027-17.895,6.807,6.807,0,0,1-.089-1.1,7.586,7.586,0,0,1,7.577-7.577,7.159,7.159,0,0,1,1.054.078,9.845,9.845,0,0,1,19.527,1.791,9.028,9.028,0,0,1-.158,1.664,11.577,11.577,0,0,1,9.1,11.351A11.7,11.7,0,0,1,50.018,91.644M32.182,67.77A4.884,4.884,0,0,0,27.3,72.648a4.83,4.83,0,0,0,.3,1.616,1.349,1.349,0,0,1-1.035,1.778,6.5,6.5,0,0,0,1.151,12.9h22.3a8.963,8.963,0,0,0,.777-17.895,1.35,1.35,0,0,1-1.158-1.785,7.048,7.048,0,0,0,.426-2.325,7.146,7.146,0,0,0-14.292-.074,1.35,1.35,0,0,1-1.836,1.245,4.849,4.849,0,0,0-1.753-.342",
    transform: "translate(-1.857 -5.728)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 21.946,
    transform: "translate(39.654 84.295)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.699,
    height: 21.947,
    transform: "translate(38.304 84.294)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 22.439,
    transform: "translate(39.654 61.856)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.925,92.392a1.35,1.35,0,0,1-1.35-1.35V68.6a1.35,1.35,0,1,1,2.7,0V91.042a1.35,1.35,0,0,1-1.35,1.35",
    transform: "translate(-4.271 -6.747)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.071,
    y2: 4.737,
    transform: "translate(39.654 72.85)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.925,86.908a1.349,1.349,0,0,1-.752-2.47L50.245,79.7a1.349,1.349,0,1,1,1.5,2.241l-7.071,4.737a1.337,1.337,0,0,1-.75.229",
    transform: "translate(-4.271 -7.973)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    x2: 7.071,
    y2: 4.736,
    transform: "translate(32.582 68.544)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.135,82.123a1.344,1.344,0,0,1-.75-.229l-7.071-4.737a1.349,1.349,0,1,1,1.5-2.242l7.071,4.737a1.349,1.349,0,0,1-.752,2.471",
    transform: "translate(-3.483 -7.493)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.815,74.864A6.187,6.187,0,0,0,126.726,67a8.5,8.5,0,0,0-16.991.087,8.4,8.4,0,0,0,.5,2.766,10.312,10.312,0,0,0,.9,20.588h22.3a7.852,7.852,0,0,0,1.388-15.581",
    transform: "translate(-10.112 -5.878)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.276,91.644h-22.3A11.7,11.7,0,0,1,99.291,79.956a11.581,11.581,0,0,1,9.1-11.352,8.837,8.837,0,0,1-.158-1.663,9.845,9.845,0,0,1,19.526-1.791,7.159,7.159,0,0,1,1.054-.078,7.586,7.586,0,0,1,7.578,7.577,7.047,7.047,0,0,1-.089,1.1,9.2,9.2,0,0,1-3.027,17.894M118.084,59.79a7.158,7.158,0,0,0-7.15,7.151,7.05,7.05,0,0,0,.425,2.325,1.349,1.349,0,0,1-1.158,1.786,8.963,8.963,0,0,0,.778,17.894h22.3a6.5,6.5,0,0,0,1.151-12.9,1.349,1.349,0,0,1-1.035-1.778,4.826,4.826,0,0,0,.3-1.616,4.845,4.845,0,0,0-6.631-4.537,1.349,1.349,0,0,1-1.837-1.244,7.169,7.169,0,0,0-7.142-7.077",
    transform: "translate(-9.961 -5.728)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 21.946,
    transform: "translate(109.525 84.295)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.699,
    height: 21.947,
    transform: "translate(108.175 84.294)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 22.439,
    transform: "translate(109.525 61.856)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.588,92.392a1.35,1.35,0,0,1-1.35-1.35V68.6a1.35,1.35,0,1,1,2.7,0V91.042a1.35,1.35,0,0,1-1.35,1.35",
    transform: "translate(-12.063 -6.747)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    x2: 7.071,
    y2: 4.737,
    transform: "translate(102.453 72.85)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.8,86.908a1.337,1.337,0,0,1-.75-.229l-7.071-4.737a1.349,1.349,0,1,1,1.5-2.241l7.071,4.737a1.349,1.349,0,0,1-.752,2.47",
    transform: "translate(-11.274 -7.973)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.071,
    y2: 4.736,
    transform: "translate(109.525 68.544)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.588,82.123a1.349,1.349,0,0,1-.752-2.471l7.071-4.737a1.349,1.349,0,0,1,1.5,2.242l-7.071,4.737a1.344,1.344,0,0,1-.75.229",
    transform: "translate(-12.063 -7.493)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon_1.eaa6f3d4f85792e414089335f4befdaa.svg";
export { ForwardRef as ReactComponent };